/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import defaultBannerItemLayout from './defaultBannerItemLayout';
import imageOnlyLayout from './imageOnlyLayout';
import cardBannerItemLayout from './cardBannerItemLayout';
import imageTextOnRightBannerItemLayout from './imageTextOnRightBannerItemLayout';
import imageTextOnLeftBannerItemLayout from './imageTextOnLeftBannerItemLayout';
import videoOnlyLayout from './videoOnlyLayout';
import videoWithTextLayout from './videoWithTextLayout';
import textOnlyLayout from './textOnlyLayout';
import searchQuietLayout from './searchQuietBannerItemLayout';
import searchStandardLayout from './searchStandardBannerItemLayout';
import contextBannerLayout from './contextBannerLayout';
import { BANNER_ITEM_LAYOUTS } from '../layoutConstants';

export default {
    [BANNER_ITEM_LAYOUTS.DEFAULT]: defaultBannerItemLayout,
    [BANNER_ITEM_LAYOUTS.IMAGE_ONLY]: imageOnlyLayout,
    [BANNER_ITEM_LAYOUTS.CARD_LAYOUT]: cardBannerItemLayout,
    [BANNER_ITEM_LAYOUTS.IMAGE_WITH_TEXT_ON_RIGHT]: imageTextOnRightBannerItemLayout,
    [BANNER_ITEM_LAYOUTS.IMAGE_WITH_TEXT_ON_LEFT]: imageTextOnLeftBannerItemLayout,
    [BANNER_ITEM_LAYOUTS.VIDEO_ONLY]: videoOnlyLayout,
    [BANNER_ITEM_LAYOUTS.VIDEO_WITH_TEXT]: videoWithTextLayout,
    [BANNER_ITEM_LAYOUTS.TEXT_ONLY]: textOnlyLayout,
    [BANNER_ITEM_LAYOUTS.SEARCH_QUIET]: searchQuietLayout,
    [BANNER_ITEM_LAYOUTS.SEARCH_STANDARD]: searchStandardLayout,
    [BANNER_ITEM_LAYOUTS.CONTEXT_BANNER]: contextBannerLayout,
};
